import { BACKEND_URL } from "@/App";

export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;
const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif", "image/heic", "image/heif"];

export const photoSrc = (url) => (url?.startsWith("/") ? `${BACKEND_URL}${url}` : url);

/** Ridimensiona, ruota e comprime la foto nel browser: una foto da telefono
 *  (3-5 MB) diventa ~300-600 KB restando perfettamente leggibile. */
export async function processPhoto(file, rotation = 0, maxDim = 2000, quality = 0.82) {
  const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
  const scale = Math.min(1, maxDim / Math.max(bitmap.width, bitmap.height));
  const w = Math.round(bitmap.width * scale);
  const h = Math.round(bitmap.height * scale);
  const swap = rotation === 90 || rotation === 270;
  const canvas = document.createElement("canvas");
  canvas.width = swap ? h : w;
  canvas.height = swap ? w : h;
  const ctx = canvas.getContext("2d");
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((rotation * Math.PI) / 180);
  ctx.drawImage(bitmap, -w / 2, -h / 2, w, h);
  bitmap.close?.();
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
  return blob;
}

export async function uploadHaccpPhoto(authAxios, file, rotation = 0) {
  if (file.type && !ALLOWED_TYPES.includes(file.type)) {
    throw new Error("Formato foto non supportato (usa JPG o PNG)");
  }
  let payload = file;
  try {
    const blob = await processPhoto(file, rotation);
    if (blob) payload = blob;
  } catch {
    if (file.size > MAX_PHOTO_BYTES) throw new Error("Foto troppo grande (max 5MB)");
  }
  if (payload.size > MAX_PHOTO_BYTES) throw new Error("Foto troppo grande anche dopo la compressione");
  const fd = new FormData();
  fd.append("file", payload, "scheda.jpg");
  const r = await authAxios.post("/haccp/photo", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return r.data.url;
}

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const currentMonth = () => new Date().toISOString().slice(0, 7);

export const fmtDay = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};
